import { render } from "./Laboratoire.vue?vue&type=template&id=6ce0f390&ts=true"
import script from "./Laboratoire.vue?vue&type=script&lang=ts"
export * from "./Laboratoire.vue?vue&type=script&lang=ts"

import "./Laboratoire.vue?vue&type=style&index=0&id=6ce0f390&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__